import { render, staticRenderFns } from "./ComparisonConfig.vue?vue&type=template&id=714c80b6&"
import script from "./ComparisonConfig.vue?vue&type=script&lang=js&"
export * from "./ComparisonConfig.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonConfig.vue?vue&type=style&index=0&id=714c80b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports